export type ReturnsExclusionsMessage = {
  title: string;
  message: string;
  matches: {
    category: string;
    sellingProductTypes: string[];
  }[];
};

export const returnsExclusionsMessages: ReturnsExclusionsMessage[] = [
  {
    title: "Returns restrictions apply to this item",
    message:
      "Unless faulty, you can only return this item if unopened, unused and with the original seals or tags intact. This does not affect your statutory rights.",
    matches: [
      { category: "6000460144", sellingProductTypes: ["Earrings"] },
      {
        category: "600001812",
        sellingProductTypes: ["Knickers", "Bras", "Bodysuits & Basques"],
      },
      { category: "600001542", sellingProductTypes: ["Pants"] },
      { category: "300000004198", sellingProductTypes: ["Knickers"] },
      { category: "90000360020", sellingProductTypes: ["Pants"] },
      { category: "60000922", sellingProductTypes: ["Swimsuit"] },
      { category: "600001887", sellingProductTypes: ["Swim Shorts"] },
      { category: "700002430", sellingProductTypes: ["Swimsuit"] },
      {
        category: "700002410",
        sellingProductTypes: ["Swimsuit", "Swim Shorts"],
      },
      {
        category: "50000296",
        sellingProductTypes: [
          "Perfumes",
          "Lip Liners",
          "Gift Boxes",
          "Gift Sets",
          "Specialist Skin Treatments",
          "Fake Tan Remover",
          "Self Tan",
          "Tanning Mitts",
          "Sun Cream",
          "After Sun",
          "Neck Cream",
          "Hand Sanitiser",
          "Hand Cream",
          "Eyelash Curlers",
          "Concealer",
          "Bronzers",
          "Make-Up Remover",
          "Makeup Brushes",
          "Makeup Sponges & Pads",
          "Setting Spray",
          "Face Cleansing Brushes",
          "Face Mask",
          "Face Steamers",
          "Face Rollers",
          "Mascaras",
          "Foundations",
          "Talcum Powder",
          "Base & Top Coats",
          "Nail Treatments",
          "Lip Plumper",
          "Lip Gloss",
          "Lip Treatments",
          "Lip Exfoliator",
          "Lipsticks",
          "Hand Cream",
          "Cuticle Remover",
          "Cuticle Pushers",
          "Cuticle Oil",
          "Nail Oil",
          "Nail Polish Remover",
          "Nail Files & Buffers",
          "Nail Sets",
          "Nail Polish",
          "False Nails",
          "Postnatal Toiletry",
          "Prenatal Toiletry",
          "Face Mask",
          "Eyebrow Kits",
          "Eyebrow Pencils",
          "Eyebrow Gels",
          "Cleansers",
          "Moisturisers",
          "Eye Primers",
          "Primers",
          "Highlighters",
          "Tinted Moisturisers",
          "Foot Files",
          "Foot Cream",
          "Foot Peel Masks",
          "Soap",
          "Hand Wash",
          "Atomiser",
          "False Eyelashes",
          "Eyeshadows",
          "Tweezers",
          "Powders",
          "Cleansing Mitts",
          "Exfoliating Mitts",
          "Exfoliators & Scrubs",
          "Moisture Absorbers",
          "Oils",
          "Bubble Bath",
          "Bath Oil",
          "Bath Milk",
          "Bath Soak",
          "Bath Salts",
          "Bath Salts",
          "Health Drinks",
          "Shower Gel",
          "Body Brushes",
          "Body Butter",
          "Leg Cream",
          "Face Massagers",
          "Face Mists",
          "Body Mist",
          "Body Spray",
          "Pillow Mist",
          "Room Sprays",
          "Candles",
          "Lubricant",
          "Sex Toy",
          "Hair Mist",
          "Perfumes",
          "Supplements",
          "Deodorants",
          "Aftershave",
          "Anti-Perspirants",
          "Blackhead Removers",
          "Toners",
          "Hair Treatments",
          "Hair Putty",
          "Hair Dyes & Colouring",
          "Hair Mousse",
          "Hair Spray",
          "Hair Masks",
          "Hair Powder",
          "Lash or Brow Serum",
          "Serums",
          "Hair Serum",
          "Hair Powder",
          "Hair Balm",
          "Hair Wax",
          "Hair Gel",
          "Hair Combs",
          "Hair Brushes",
          "Hair Clay",
          "Wipes",
          "Eye Mask",
          "Blushers",
          "Eyeliners",
          "Eye Cream",
          "Hair Cream",
          "Body Lotion",
          "Scissors",
          "Body Spray",
          "Hair Gel",
          "Conditioner",
          "Colour Correctors",
          "Beard Shampoo",
          "Beard Oil",
          "Beard Conditioner",
          "Beard Balm",
          "Shaving Cream, Foam, Gel & Oil",
          "Aftershave",
          "After Shave Balm",
          "Shampoo",
          "Sports Massagers",
          "Face Mask",
          "Plants",
          "Nail Clippers & Scissors",
          "Beard Groom Kit",
          "Trimmers",
          "Electric Shavers",
          "LED Light Therapy",
          "IPL Hair Removal",
          "Epilators",
          "Tweezers",
          "Shaving Kits",
          "Toothbrush Heads",
          "Electric Toothbrush",
          "Electric Flossing",
          "Nipple Shields",
          "Breast Pads",
          "Breast Therapy Packs",
          "Breast Pumps",
        ],
      },
    ],
  },
  {
    title: "Returns restrictions apply to this item",
    message:
      "You can only return this item if faulty or not as described. This does not affect your statutory rights.",
    matches: [
      {
        category: "5904501226",
        sellingProductTypes: [
          "Alcohol",
          "Biscuits",
          "Sweets & Fudge",
          "Tea",
          "Hot Chocolate",
          "Gift Food Sets",
          "Hampers",
          "Coffee",
          "Cakes",
          "Chocolates & Boxes of Chocolate",
        ],
      },
      { category: "20000030030", sellingProductTypes: ["Plants"] },
      {
        category: "300000012646",
        sellingProductTypes: ["Hampers", "Fresh Flower Bouquet"],
      },
    ],
  },
  {
    title: "Returns restrictions apply to this item",
    message:
      "Unless faulty, you can only return this item if unopened, unused and with the original seals or tags intact. This does not affect your statutory rights.",
    matches: [
      {
        category: "60000246",
        sellingProductTypes: [
          "Bed Sheets",
          "Sleeping Bags",
          "Duvets",
          "Baby Blankets",
          "Pillows",
          "Throws",
          "Deep Fitted Sheets",
          "Pillow & Mattress Protectors",
          "Bedspreads",
          "Mattress Toppers",
          "Valances",
          "Electric Blanket",
          "Weighted Blankets",
          "Travel Pillows & Blankets",
          "Blankets",
          "Duvet Cover",
        ],
      },
      { category: "700008951", sellingProductTypes: ["Toilet Seats"] },
      { category: "20000450150", sellingProductTypes: ["Mattresses"] },
    ],
  },
  {
    title: "Returns restrictions apply to this item",
    message:
      "Unless faulty or not a as described, you can only return this item if unopened and not redeemed. This does not affect your statutory rights. Read our full returns policy.",
    matches: [
      { category: "6000041", sellingProductTypes: ["Video Games"] },
      { category: "9200010055", sellingProductTypes: ["Software"] },
    ],
  },
  {
    title: "Returns restrictions apply to this item",
    message:
      "Our usual exchange and refund policy doesn’t apply to products that are made to order or made to measure, which cannot be cancelled, returned or exchanged. This doesn't affect your statutory rights if goods are faulty, or not as described.",
    matches: [{ category: "9780211017", sellingProductTypes: ["Blinds"] }],
  },
];
